module.exports = "/dist/assets/images/vipps-logo.svg";